var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{staticClass:"mb-2 process-history",attrs:{"data":_vm.processInstanceInfo.log,"columns":_vm.processHistoryColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }